import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ReCaptchaProvider"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/PageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/app/context/app-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/global-layout/global-components/termlyEmbedScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/styles/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-rubik\",\"weight\":[\"400\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"rubik\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/utils/theme.ts");
